module.exports = __webpack_public_path__ + "img/second-cup.4f48f15d.webp";